import { useSelector } from 'react-redux';
import {
    Box,
    Flex,
    HStack,
    InputLeftElement,
    // Switch, // "Overstamp differs" toggle
} from '@chakra-ui/react';
import { CloseIcon, SearchIcon } from '@chakra-ui/icons';
import { GrPowerReset } from 'react-icons/gr';
import {
    // Button, // "Filtering by" bar
    Input,
    InputGroup,
    InputRightElement,
    // Text, // "Filtering by" bar, "Overstamp differs" toggle
} from '@/components/v4';
// import { Chip } from '@/components/v4/ChipInput/Chip'; // "Filtering by" bar
import CollapsibleButtonGroup from 'components/presentational/CollapsibleButtonGroup';
import TableIconButton from 'components/tables/AGGrid/TableIconButton';
import { searchStyling } from 'components/tables/AGGrid/agGridStyles';
// import { getActiveFilterChips } from '../utils/filters'; // "Filtering by" bar

// const OVERSTAMP_SWITCH_ID = 'bulk-overstamp-differs'; // "Overstamp differs" toggle

/**
 * The All Numbers toolbar, laid out like the Numbers page table toolbar:
 * actions on the left and search on the right. Column values (country,
 * status, trunk…) are filtered from the column headers, and number patterns
 * (contains, starts with, length, regex…) from the Number column's filter.
 *
 * Commented out until they're wanted, each restored by uncommenting every
 * line marked with its name in this file:
 * - "Filtering by" bar: active filter chips with Clear all (the All Numbers
 *   footer's Reset Filters clears everything meanwhile).
 * - "Overstamp differs" toggle: shows numbers whose Overstamp isn't the
 *   number itself. Its filter column stays in the grid, unused.
 */
const FilterToolbar = ({
    filters,
    onChange,
    // onRemoveFilter, // "Filtering by" bar
    // onClearAll, // "Filtering by" bar
    onOpenPasteList,
    onRefresh,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    // const { colorScheme } = useSelector((state) => state.settings); // "Overstamp differs" toggle
    // const chips = getActiveFilterChips(filters); // "Filtering by" bar
    const borderColor = darkMode ? 'dark.tcap-borderGray' : 'gray.200';

    const set = (changes) => onChange({ ...filters, ...changes });

    const actions = [
        {
            key: 'paste-list',
            label: 'Paste List',
            tooltip: 'Paste numbers to select them',
            onClick: onOpenPasteList,
        },
    ];

    return (
        <Box
            px={4}
            py="15px"
            borderBottom="1px solid"
            borderColor={borderColor}>
            <Flex align="center" gap={3}>
                <CollapsibleButtonGroup
                    items={actions}
                    menuLabel="Find Numbers"
                    flexShrink={0}
                />
                {/* "Overstamp differs" toggle
                <HStack
                    spacing={2}
                    flexShrink={0}
                    title="Show numbers whose Overstamp is not the number itself">
                    <Text
                        as="label"
                        htmlFor={OVERSTAMP_SWITCH_ID}
                        fontSize="xs"
                        m={0}
                        cursor="pointer"
                        whiteSpace="nowrap">
                        Overstamp differs
                    </Text>
                    <Switch
                        id={OVERSTAMP_SWITCH_ID}
                        size="sm"
                        colorScheme={colorScheme}
                        isChecked={filters.overstampDiffers}
                        onChange={(e) =>
                            set({ overstampDiffers: e.target.checked })
                        }
                    />
                </HStack> */}
                <HStack spacing={0} flex="1" justify="flex-end" minW={0}>
                    <InputGroup maxW="240px" minW="140px">
                        <InputLeftElement pointerEvents="none" height="30px">
                            <SearchIcon color="gray.300" />
                        </InputLeftElement>
                        <Input
                            aria-label="Search numbers"
                            placeholder="Search numbers..."
                            inputMode="numeric"
                            sx={{ ...searchStyling, width: '100%' }}
                            // InputGroup only pads Chakra's own Input, not the v4 wrapper
                            pl={8}
                            pr={8}
                            bg={darkMode ? 'dark.bgDark' : 'white'}
                            value={filters.search}
                            onChange={(e) => set({ search: e.target.value })}
                        />
                        {filters.search && (
                            <InputRightElement height="30px">
                                <CloseIcon
                                    boxSize="10px"
                                    cursor="pointer"
                                    color="gray.300"
                                    aria-label="Clear search"
                                    onClick={() => set({ search: '' })}
                                />
                            </InputRightElement>
                        )}
                    </InputGroup>
                    <TableIconButton
                        icon={<GrPowerReset />}
                        onClick={onRefresh}
                        tooltip="Refresh Table"
                    />
                </HStack>
            </Flex>

            {/* "Filtering by" bar
            {chips.length > 0 && (
                <Flex
                    align="center"
                    wrap="wrap"
                    gap={1}
                    mt={3}
                    pt={2}
                    borderTop="1px dashed"
                    borderColor={
                        darkMode ? 'dark.tcap-borderGray' : 'gray.300'
                    }>
                    <Text
                        fontSize="xs"
                        fontWeight="semibold"
                        color="gray.500"
                        mr={1}>
                        Filtering by
                    </Text>
                    {chips.map((chip, index) => (
                        <Chip
                            key={chip.key}
                            input={chip.label}
                            index={index}
                            onCloseClick={() => onRemoveFilter(chip.key)}
                        />
                    ))}
                    <Button
                        variant="link"
                        size="sm"
                        ml="auto"
                        colorScheme="red"
                        onClick={onClearAll}>
                        Clear all
                    </Button>
                </Flex>
            )} */}
        </Box>
    );
};

export default FilterToolbar;
